import { useState, useEffect } from 'react';
import axios from 'axios';

const usePageHeaders = () => {
  const [headers, setHeaders] = useState({});

  useEffect(() => {
    const fetchHeaders = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL || 'https://konveksiimoonusel.com/api'}/get_page_headers.php`);
        setHeaders(res.data);
      } catch (err) {
        console.error('Failed to fetch page headers:', err);
      }
    };
    fetchHeaders();
  }, []);

  return headers;
};

export default usePageHeaders;
